/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import * as types from "./types";

const mutations = {
  [types.SET_TRANSLATIONS](state, {translations}){
    state.data = translations;
  },
  [types.SET_UPCHARGE](state, {upcharge}){
    state.upcharge = upcharge;
  }
}

export default mutations;